module.exports = __webpack_public_path__ + "static/img/zhongBottomNew3.e5b1803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/zhongBottomNew3.png
// module id = lLjY
// module chunks = 0